import Lottie from 'react-lottie-player';
import LoadingAnimationDots from '../../assets/animations/LoadingAnimationDots.json';
import { WithClassname } from '../../types';
import React from 'react';

type Props = WithClassname & {
  src?: object;
  style?: object;
};

export default function LoadingIndicator({
  src = LoadingAnimationDots,
  style = {},
  className = null,
}: Props) {
  return (
    <Lottie
      animationData={src}
      play
      loop
      style={style}
      className={className}
      rendererSettings={{
        preserveAspectRatio: 'xMidYMid slice',
      }}
    />
  );
}
